import React from 'react';
import { PlusIcon } from "../../assets/admin/icons/plusicon";

const AddNewFAQButton: React.FC<AddNewFAQButtonProps> = ({
  onClick,
  label,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px 20px 2px 12px',
        height: '44px',
        borderRadius: '8px',
        border: '1px solid #1819B4',
        backgroundColor: '#fff',
        color: '#1819B4',
        fontSize: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'Inter, Arial, sans-serif',
        gap: '8px',
      }}
    >
      <PlusIcon style={{ width: '18px', height: '18px' }} />
      {label}
    </button>
  );
};

export default AddNewFAQButton;
